import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkHeight',
})
export class CheckHeightPipe implements PipeTransform {
  async transform(e: HTMLElement, ...args: unknown[]): Promise<Boolean> {
    const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));
    await delay(50);
    const heightToCompare: any = args[0];
    if (e.offsetHeight > heightToCompare) {
      e.classList.add('closed');
      return true;
    } else {
      return false;
    }
  }
}
